// @flow
import * as React from 'react';

type MenuPlacement = {
    menuPlacement: string | undefined,
    menuPortalTarget: React.Node | undefined,
}

const SelectMenuPlacementContext: React.Context<MenuPlacement | null> = React.createContext(null);

export default SelectMenuPlacementContext;
